import { Component, HostListener, OnInit, inject } from '@angular/core';
import { HomePageService } from './services/home-page/home-page.service';
import { GenericService } from './services/generic.service';
import { AuthService } from './services/auth.service';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { clearInterval, clearTimeout, setInterval, setTimeout } from 'worker-timers';
import { CommonModule } from '@angular/common';

// Kendo UI importss
import { DialogsModule } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    DialogsModule
  ]
})
export class AppComponent implements OnInit 
{
  isResized: boolean = false;
  public autoLogoutRunning: boolean = false;
  private idleTime = 0;
  private idleInterval: any;
  public showCookiePopup: boolean = false;


  constructor(
    private homePageService: HomePageService,
    private genericService: GenericService,
    private authService: AuthService,
    private router: Router,

  ) 
  {
    this.homePageService.resizeEvent.subscribe((resize: boolean) =>
    {
      // this.isResized = resize;
    });

    // GET SITE MESSAGES
    this.genericService.getSiteMessages();

    // GET SITE VARIABLES
    this.genericService.getSiteVariables();
  }

  ngOnInit(): void 
  {
    if (!this.checkLocalStorageWorks ()) {
      this.showCookiePopup = true;
    }

    if (this.authService.isLoggedIn())
    {
      // getUserInfo() REJECTS WHEN THE REQUEST FAILS (STATUS 0: NETWORK DROPPED, OR THE PAGE WAS LEFT
      // MID-REQUEST). NOTHING AWAITS IT HERE, SO WITHOUT THE CATCH THAT IS AN UNHANDLED ERROR IN SENTRY.
      this.authService.getUserInfo().catch((error: any) => {
        console.error('getUserInfo() failed:', error);
      });
    }

    // MONITORING ROUTE CHANGES TO ADJUST IDLE TIMEOUT.
    this.router.events.subscribe((event: any) =>
    {
      if (event instanceof NavigationEnd)
      {
        // RUN THE AUTO LOGOUT SCRIPT.
        this.doAutoLogout();
      }
    });

    // RUN THE AUTO LOGOUT SCRIPT.
    this.doAutoLogout();
  }

  // RUN THE AUTO LOGOUT SCRIPT.
  public doAutoLogout()
  {
    // IF IDLE TIME LIMIT IS SET
    if (this.genericService.idleLimit)
    {
      // IF PREVIOUS INTERVAL FUNCTION FOUND
      if (this.idleInterval)
      {
        // CLEAR THE PREVIOUS INTERVAL
        clearInterval(this.idleInterval);
      }

      // SETUP TIMER INTERVAL TO CHECK FOR IDLE TIME EVERY SECOND
      this.idleInterval = setInterval(() => 
      {
        this.idleTime += 1000;

        // IF USER IS ON LOAN APPLICATION PAGE
        if (this.router.url.includes('/loan-application'))
        {
          // CHECK WITH FILE IDLE TIME
          let checkTime = this.genericService.fileIdleLimit;

          // IF THE IDLE TIME EXCEED SITE VARIABLE TIME LIMIT, LOGOUT USER AUTOMATICALLY.
          if (this.idleTime >= checkTime) 
          {
            // REDIRECT THE USER TO DASHBOARD
            this.router.navigate(["/dashboard"]);
          }
        }
        else
        {
          // IF USER IS ON OUSIDE OF LOAN APPLICATION PAGE
          // CHECK WITH AUTO LOGOUT IDLE TIME
          let checkTime = this.genericService.idleLimit;

          // IF THE IDLE TIME EXCEED SITE VARIABLE TIME LIMIT, LOGOUT USER AUTOMATICALLY.
          if (this.idleTime >= checkTime) 
          {
            // LOG OUT THE USER
            this.authService.logout('SESSION_TIMEOUT');
          }
        }
      }, 1000);

    } 
    else
    {
      setTimeout(() =>
      {
        this.doAutoLogout();
      }, 500);
    }
  }

  // RESET IDLE TIME ON USER ACTIVITY
  @HostListener('window:click') @HostListener('window:keypress')
  resetIdleTimer() 
  {
    // RESET IDLE TIME ON ANY ACTIVITY
    this.idleTime = 0;
  }

  checkLocalStorageWorks () 
  {
    const testKey = 'test_key_' + Date.now();
    try 
    {
      localStorage.setItem(testKey, 'test');
      const result = localStorage.getItem(testKey);
      localStorage.removeItem(testKey);
      return result === 'test';
    } 
    catch (e) 
    {
      return false;
    }
  }

  public close() {
		this.showCookiePopup = false;
	}
}
